module.exports = __webpack_public_path__ + "_/_/src/static/download/poster_CMYK_eng.pdf";